module.exports = __webpack_public_path__ + "img/b3.258770f2.jpg";